// extracted by mini-css-extract-plugin
module.exports = {"dropDownTitleContainer":"VIP_DropdownTitle__dropDownTitleContainer","dropDownTitle":"VIP_DropdownTitle__dropDownTitle"};